import React from "react";
import {
  Grid,
  Modal,
  Button,
} from "@mui/material";
import s from "./ModalFiltros.module.css";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import "dayjs/locale/es";
import "dayjs/locale/pt";
import { minDateRange } from "../../../../config/strings";
import { useSelector } from "react-redux";

const ModalFiltros = ({
  open,
  setOpen,
  setFilters,
  setSearching,
  setSearch,
  dateDesde,
  setDateDesde,
  dateHasta,
  setDateHasta,
}) => {
  const { t, i18n } = useTranslation();
  const agencieSelected = useSelector(
    (state) => state.myAgencies?.selected_agencie_to_consult,
  );

  const formatDate = (d) =>
    `${d.$D < 10 ? "0" : ""}${d.$D}/${d.$M + 1 < 10 ? "0" : ""}${d.$M + 1}/${d.$y}`;

  const handleDesde = (date_picked) => {
    setDateDesde(date_picked);
    setFilters((prev) => ({ ...prev, fechadesde: formatDate(date_picked) }));
  };

  const handleHasta = (date_picked) => {
    setDateHasta(date_picked);
    setFilters((prev) => ({ ...prev, fechahasta: formatDate(date_picked) }));
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Grid container>
        <Grid
          xs={12}
          md={8}
          lg={4.5}
          item
          container
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid item xs={10} className={s.exit}>
            <div className={s.titleModal}>
              <p>{t("filter")}</p>
              <span>{t("filterConfig")}</span>
            </div>
            <CloseIcon
              onClick={() => setOpen(false)}
              className={s.exitIcon}
              sx={{ color: "primary.dark" }}
            />
          </Grid>

          <Grid item container xs={10} sx={{ mt: 5 }}>
            <Grid sx={{ fontSize: "1.2rem", marginBottom: 2 }} item xs={12}>
              {t("dateRange")}
            </Grid>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale={i18n.language}
            >
              <Grid item xs={12} sx={{ mb: 3 }}>
                <DatePicker
                  label={t("from")}
                  inputFormat="DD/MM/YYYY"
                  value={dateDesde}
                  onChange={handleDesde}
                  renderInput={(params) => (
                    <TextField {...params} sx={{ width: "100%" }} />
                  )}
                  minDate={minDateRange}
                  maxDate={new Date()}
                />
              </Grid>
              <Grid item xs={12} sx={{ mb: 3 }}>
                <DatePicker
                  label={t("to")}
                  inputFormat="DD/MM/YYYY"
                  value={dateHasta}
                  onChange={handleHasta}
                  renderInput={(params) => (
                    <TextField {...params} sx={{ width: "100%" }} />
                  )}
                  minDate={minDateRange}
                  maxDate={new Date()}
                />
              </Grid>
            </LocalizationProvider>
          </Grid>

          <Grid
            item
            xs={10}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              my: "20px",
            }}
          >
            <Button
              variant="contained"
              disabled={!agencieSelected}
              onClick={() => {
                setOpen(false);
                setSearching(true);
                setSearch(true);
              }}
            >
              {t("search")}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ModalFiltros;
